import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

type CustomICon = BoxProps & {
  children: ReactNode;
};

const CustomICon = ({ children, ...props }: CustomICon) => {
  return (
    <Box
      className="w-10 h-10 flex justify-center items-center text-white cursor-pointer select-none rounded hover:bg-[#1A5EAA]"
      {...props}
    >
      {children}
    </Box>
  );
};
export default CustomICon;
